import { Field } from '@campfire/field';
import { TabletButton } from '@campfire/tablet-button';
import { Formik, Form } from 'formik';
import { ArrowForwardIos } from '@material-ui/icons';
import { cloneDeep } from 'lodash';
import {
  DialogTitle,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  DialogActions,
  CircularProgress,
  Box,
} from '@material-ui/core';
import React from 'react';
import { object as YupObject, string as YupString } from 'yup';
import {
  IncidentCategoryGroupType,
  CategoriesSectionContent,
  findGroup,
  IncidentDetailType,
} from '../../admin-console-incident-report-model';
import { useAdminConsoleActions } from '../../../../admin-console-actions';

type Props = {
  open: boolean;
  onClose: () => void;
  incidentCategoriesRoot: IncidentCategoryGroupType;
  parentGroup: IncidentCategoryGroupType;
  refetchCategories?: () => void;
};

const validationSchema = YupObject().shape({
  label: YupString()
    .trim()
    .required('Please provide a category name'),
});
export const AddCategoryDialog = ({ open, onClose, incidentCategoriesRoot, parentGroup, refetchCategories }: Props) => {
  const { runSaveIncidentCategories, runSaveIncidentCategoriesLoading } = useAdminConsoleActions();
  const { sectionTitle, addCategoryDialogTitle, addCategoryDialogHelperText } = CategoriesSectionContent;
  const handleSuccess = () => {
    onClose();
    if (refetchCategories) refetchCategories();
  };

  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Grid item container xs={12} direction='column' style={{}}>
          <Typography variant='h6' gutterBottom>
            {addCategoryDialogTitle}
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            {addCategoryDialogHelperText}
          </Typography>
          <Box display='flex' alignItems='center'>
            <Typography variant='body1'>{sectionTitle}</Typography>
            {parentGroup && parentGroup.incidentCategoryGroupId !== incidentCategoriesRoot.incidentCategoryGroupId && (
              <>
                <ArrowForwardIos style={{ fontSize: 18, paddingRight: 8, paddingLeft: 8 }} />
                <Typography variant='body1' display='inline'>
                  {parentGroup.label}
                </Typography>
              </>
            )}
          </Box>
        </Grid>
      </DialogTitle>
      <Formik
        initialValues={{
          label: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(vals) => {
          if (parentGroup?.incidentCategoryGroupId) {
            const clonedRoot = cloneDeep(incidentCategoriesRoot);
            const foundGroupForAddition = findGroup(clonedRoot, parentGroup?.incidentCategoryGroupId);
            if (foundGroupForAddition)
              foundGroupForAddition.categories.push({
                __typename: 'VOLUNTEER_IncidentCategoryType',
                label: vals.label,
                details: [] as IncidentDetailType[],
              });
            runSaveIncidentCategories({ root: clonedRoot, handleSuccess });
          }
        }}
      >
        {() => (
          <Form>
            <DialogContent>
              <Field
                required
                autoFocus
                name='label'
                label='Category Name'
                variant='outlined'
                margin='normal'
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <TabletButton variant='text' onClick={() => onClose()}>
                {'Cancel'}
              </TabletButton>
              <TabletButton variant='contained' color='primary' type='submit'>
                {runSaveIncidentCategoriesLoading ? <CircularProgress size={20} /> : 'Done'}
              </TabletButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
